import { Pipe, PipeTransform } from '@angular/core';
import { TicketData } from '../../../../../core/modules/tickets/ticket.types';

@Pipe({
  name: 'ticketMeasureUnits',
  standalone: true,
})
export class TicketMeasureUnitsPipe implements PipeTransform {
  transform(ticketData: TicketData):string[] {
    return ticketData.ticket.items.map(item => (item.commodity
      ? ticketData.measureUnits[item.commodity.measureUnitCode]
      : ''));
  }
}
